import Select from "react-select";
import { useLayout } from "../../../../contexts/UseLayout";
import { useEffect } from "react";
import { FiltrosProps, MesesList } from "./Mock";
import { useQuery } from "@tanstack/react-query";
import CadastroAgenciaService from "@/services/cadastroAgencia";
import ServiceRepresentantes from "@/services/serviceRepresentante";
import ServiceRepresentado from "@/services/serviceRepresentado";
import { useTranslation } from "react-i18next";

export function Filtros({
  type_user,
  setType_user,
  agencySelect,
  setAgencySelect,
  representanteSelect,
  setRepresentanteSelect,
  mes,
  setMes,
  representadoSelect,
  setRepresentadoSelect,
  regiaoSelect,
  setRegiaoSelect,
  areaSelecionada,
  setAreaSelecionada,
  cargoSelecionado,
  setCargoSelecionado,
  openFilters,
  setOpenFilters,
  setCurrentPage,
  mesAtual,
  idMenu,
  cargos,
  setCargos,
}: FiltrosProps) {
  const { t } = useTranslation();
  const getUsers = useLayout();
  const getTypeUsers: any = getUsers?.getConfig?.typeUsers;
  const typeUserLogged: any = getUsers?.userLogged?.data?.type_user_id;
  const allUfs: any = getUsers?.getConfig?.ufs;
  const allAreas: any = getUsers?.getConfig?.areas;
  const allCargos: any = getUsers?.getConfig?.cargos;

  useEffect(() => {
    if (areaSelecionada?.value !== "") {
      const cargosFiltrados = allCargos?.filter(
        (cargo: any) => cargo.id_area == areaSelecionada?.value
      );
      setCargos(cargosFiltrados);
      setCargoSelecionado("");
    } else {
      setCargos([]);
      setCargoSelecionado("");
    }
  }, [areaSelecionada, getUsers]);

  const { isPending: agenciesPending, data: listAgencies } = useQuery({
    queryKey: ["aniversariantesAgencies"],
    queryFn: async () =>
      await CadastroAgenciaService?.listarAgencys(1, 99999999999999),
    enabled:
      !!openFilters &&
      idMenu === "aniversariantes" &&
      typeUserLogged === 1 &&
      type_user?.value == 2,
    retry: 2,
    staleTime: 1000 * 60 * 5,
  });

  const { isPending: representantesPending, data: listRepresentantes } =
    useQuery({
      queryKey: ["aniversariantesRepresentantes"],
      queryFn: async () =>
        await ServiceRepresentantes?.listRepresentantes(1, 999999),
      enabled:
        !!openFilters &&
        idMenu === "aniversariantes" &&
        typeUserLogged === 1 &&
        type_user?.value == 3,
      retry: 2,
      staleTime: 1000 * 60 * 5,
    });

  const { isPending: representadosPending, data: listRepresentados } = useQuery(
    {
      queryKey: ["aniversariantesRepresentados"],
      queryFn: async () =>
        await ServiceRepresentado?.listRepresentado(1, 999999999999),
      enabled: !!openFilters && idMenu === "aniversariantes",
      retry: 2,
      staleTime: 1000 * 60 * 5,
    }
  );

  return (
    <>
      <div className="pt-10">
        <div className="w-full gap-8 text-xs bg-gray-100 rounded-2xl py-2 px-6 relative">
          <div className="grid grid-cols-3 gap-x-8 gap-y-8 text-center">
            {mes && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.month.label")}
                </span>
                <li>{mes.label}</li>
              </ul>
            )}
            {type_user && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.user.label")}
                </span>
                <li>{type_user.label}</li>
              </ul>
            )}
            {agencySelect && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.agencies.label")}
                </span>
                <li>{agencySelect.label}</li>
              </ul>
            )}
            {representanteSelect && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.representative.label")}
                </span>
                <li>{representanteSelect.label}</li>
              </ul>
            )}
            {representadoSelect && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.represented.label")}
                </span>
                <li>{representadoSelect.label}</li>
              </ul>
            )}
            {regiaoSelect && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.region.label")}
                </span>
                <li>{regiaoSelect.label}</li>
              </ul>
            )}
            {areaSelecionada && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.area.label")}
                </span>
                <li>{areaSelecionada.label}</li>
              </ul>
            )}
            {cargoSelecionado && (
              <ul className="flex flex-col flex-wrap relative py-1">
                <span className="bg-azul-400 rounded-lg w-fit text-white py-1 px-2 absolute -top-6 left-0">
                  {t("filters.position.label")}
                </span>
                <li>{cargoSelecionado.label}</li>
              </ul>
            )}
          </div>
          <div className="text-xs sm:text-sm flex gap-x-6 pt-4">
            <button
              onClick={() => setOpenFilters(!openFilters)}
              className="flex items-center justify-center border border-gray-500 rounded-xl text-gray-500 gap-2 py-1 px-5"
            >
              {t("common:filters")}
              <svg
                width="18"
                height="10"
                viewBox="0 0 18 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 1H17" stroke="#6b7280" strokeLinecap="round" />
                <path d="M4 5H14" stroke="#6b7280" strokeLinecap="round" />
                <path d="M7 9H11" stroke="#6b7280" strokeLinecap="round" />
              </svg>
            </button>
            <button
              onClick={() => {
                setType_user("");
                setAgencySelect("");
                setRepresentadoSelect("");
                setAreaSelecionada("");
                setRegiaoSelect("");
                setRepresentanteSelect("");
                setCargoSelecionado("");
                setMes({
                  value: MesesList[mesAtual].value,
                  label: MesesList[mesAtual].label,
                });
              }}
              className="flex items-center justify-center rounded-xl text-red-500 gap-2 py-1"
            >
              {t("common:clear")}
            </button>
          </div>
          <div
            className={`${
              openFilters ? "fixed inset-0 opacity-50 cursor-pointer" : "hidden"
            }`}
            onClick={() => setOpenFilters(false)}
          />
          <div
            className={`bg-white max-w-lg shadow-2xl p-4 rounded-2xl grid grid-cols-1 gap-2 md:gap-5 absolute top-full right-0 z-20 ${
              openFilters ? "w-full" : "w-0 h-0 overflow-hidden invisible"
            }`}
          >
            <Select
              options={[{ value: "", label: t("filters.month.annual") }, ...MesesList]}
              value={mes}
              placeholder={t("filters.month.select_month")}
              onChange={(e: any) => {
                setMes(e);
                setCurrentPage(1);
              }}
            />
            <Select
              value={type_user || ""}
              noOptionsMessage={() => t("common:fetch_error")}
              onChange={(value: any) => {
                setAgencySelect("");
                setRepresentadoSelect("");
                setRepresentanteSelect("");
                setType_user(value);
              }}
              placeholder={t("filters.user.select_user_type")}
              options={
                typeUserLogged === 2
                  ? getTypeUsers
                      ?.filter(
                        (cliente: any) =>
                          cliente.id == 2 ||
                          cliente.id == 3 ||
                          cliente.id == 7 ||
                          cliente.id == 8
                      )
                      .map((cliente: any) => ({
                        value: cliente.id,
                        label: cliente.name,
                      }))
                  : getTypeUsers?.map((cliente: any) => ({
                      value: cliente.id,
                      label: cliente.name,
                    })) || []
              }
            />
            {typeUserLogged === 1 && type_user?.value == 2 && (
              <Select
                isLoading={agenciesPending}
                loadingMessage={() => t("filters.agencies.loading")}
                noOptionsMessage={() => t("common:fetch_error")}
                value={agencySelect || ""}
                onChange={(value: any) => setAgencySelect(value)}
                placeholder={t("filters.agencies.select_agency")}
                options={
                  listAgencies?.data?.data?.map((item: any) => ({
                    value: item?.id,
                    label: item?.name_fantasy,
                  })) || []
                }
              />
            )}
            {typeUserLogged === 1 && type_user?.value == 3 && (
              <Select
                value={representanteSelect?.value}
                onChange={(value: any) => setRepresentanteSelect(value.value)}
                placeholder={t("filters.representative.select_representative")}
                isLoading={representantesPending}
                loadingMessage={() => t("filters.representative.loading")}
                noOptionsMessage={() => t("common:fetch_error")}
                options={
                  listRepresentantes?.data?.data?.map((item: any) => ({
                    value: item?.id,
                    label: item?.nome,
                  })) || []
                }
              />
            )}
            {typeUserLogged === 1 && type_user?.value == 4 && (
              <Select
                value={representadoSelect || ""}
                onChange={(value: any) => setRepresentadoSelect(value)}
                placeholder={t("filters.represented.select_represented")}
                isLoading={representadosPending}
                loadingMessage={() => t("filters.represented.loading")}
                noOptionsMessage={() => t("common:fetch_error")}
                options={
                  listRepresentados?.data?.data?.map((item: any) => ({
                    value: item?.id,
                    label: item?.nome,
                  })) || []
                }
              />
            )}
            <Select
              value={regiaoSelect || ""}
              onChange={(value: any) => setRegiaoSelect(value)}
              placeholder={t("filters.region.select_region")}
              noOptionsMessage={() => t("common:fetch_error")}
              options={
                allUfs?.map((item: any) => ({
                  value: item?.id,
                  label: item?.uf,
                })) || []
              }
            />
            <Select
              value={areaSelecionada || ""}
              onChange={(value: any) => setAreaSelecionada(value)}
              placeholder={t("filters.area.select_area")}
              noOptionsMessage={() => t("common:fetch_error")}
              options={
                allAreas?.map((item: any) => ({
                  value: item?.id,
                  label: item?.name,
                })) || []
              }
            />
            <Select
              value={cargoSelecionado || ""}
              onChange={(value: any) => setCargoSelecionado(value)}
              placeholder={t("filters.position.select_position")}
              isDisabled={areaSelecionada === ""}
              options={
                cargos?.map((cliente: any) => ({
                  value: cliente.id,
                  label: cliente.name,
                })) || []
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
